export const timeStringToSeconds = (time: string | null): number => {
  if (!time) return 0;
  const parts = time.split(':').map(Number);

  if (time.includes(' ')) {
    const [days, rest] = time.split(' ');
    const [hours, minutes, seconds] = rest.split(':').map(Number);
    return Number(days) * 86400 + hours * 3600 + minutes * 60 + seconds;
  }

  if (parts.length === 3) {
    return parts[0] * 3600 + parts[1] * 60 + parts[2];
  }

  return 0;
};

export const secondsToHoursAndMinutes = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return { hours, minutes };
};
